import moment from 'moment';

class CreateContractModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'CreateContractModal';
    $scope.contractName = '';
    $scope.contractShortName = '';
    $scope.selectedCustomer = 'none';

    $http.get($rootScope.apiHost+"/api/admin/customers/names", {withCredentials: true}).then(function (success) {
      $scope.customers = success.data;
    });


    let self = this;
    $scope.addContract = function () {

      $uibModalInstance.success($scope.selectedCustomer, $scope.contractName.trim(), $scope.contractShortName.toUpperCase().trim());
    }

  }
}

export default CreateContractModalController;



// WEBPACK FOOTER //
// ./client/common/modals/createContractModal/createContractModal.controller.js